export enum ProductFeeNChargeItemType {
  /** 佣金 */
  COMMISSION = '01',
  /** 手續費 */
  HADING_FEE = '02',
  /** 佣金GST */
  COMMISSION_GST = '03',
  /** 保證金 */
  SECURITY_DEPOSIT = '04',
  /** 動保設定費 */
  CHATTEL_FEE = '05',
  /** 授權費 */
  PROVISION_FEE = '06',
  /** 頭期款 */
  ADVANCED_PAYMENT = '07',
  PREMIUM = 'Premium',
  PROPERTY_INSURANCE_PREMIUM = 'PropertyInsurancePremium',
  /** 首付款 */
  UPFRONT_PAYMENT = '542801',
  /** 信託費 */
  FIDUCIARY_FEE = '9714102',
  /** 設定費 */
  BPKB_FEE = '9714101'
}
